import React from 'react';
import PropTypes from 'prop-types';
import {
  ConsentFormLineContainer,
  ConsentFormLineText,
  ConsentFormLineViewOption,
  ConsentFormLineDeleteOption,
} from '../styles';

const ConsentFormLine = ({
  consentForm,
  handleView,
  handleDelete,
}) => (
  <ConsentFormLineContainer>
    <ConsentFormLineText>
      {consentForm?.name}
    </ConsentFormLineText>
    <ConsentFormLineViewOption onClick={() => {
      handleView(consentForm);
    }}
    >
      View
    </ConsentFormLineViewOption>
    <ConsentFormLineDeleteOption onClick={() => {
      handleDelete(consentForm);
    }}
    >
      Remove
    </ConsentFormLineDeleteOption>
  </ConsentFormLineContainer>
);

// proptypes
ConsentFormLine.propTypes = {
  handleView: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  consentForm: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default ConsentFormLine;
